// Geodesic area (km²) for a polygon of [lon,lat] coords using spherical excess.
// Returns absolute area. Winding-order agnostic.
const R_KM = 6378.137;
const toRad = (d) => (d * Math.PI) / 180;

export function polygonAreaKm2(coords) {
  if (!coords || coords.length < 3) return 0;
  // Ensure closed
  const ring = coords[0] === coords[coords.length - 1] ? coords : [...coords, coords[0]];
  let total = 0;
  for (let i = 0; i < ring.length - 1; i++) {
    const [lon1, lat1] = ring[i];
    const [lon2, lat2] = ring[i + 1];
    total +=
      toRad(lon2 - lon1) *
      (2 + Math.sin(toRad(lat1)) + Math.sin(toRad(lat2)));
  }
  return Math.abs((total * R_KM * R_KM) / 2);
}

export function rectBboxCoords(sw, ne) {
  // sw, ne as [lon,lat] -> ring in [lon,lat]
  const [w, s] = sw;
  const [e, n] = ne;
  return [
    [w, s],
    [e, s],
    [e, n],
    [w, n],
    [w, s],
  ];
}

export function bboxFromCoords(coords) {
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  for (const [lon, lat] of coords) {
    if (lon < w) w = lon;
    if (lon > e) e = lon;
    if (lat < s) s = lat;
    if (lat > n) n = lat;
  }
  return [w, s, e, n];
}

// Tiered illustrative pricing matching backend
export function estimateInr(areaKm2, months = 12) {
  const t1 = 1000, t2 = 10000;
  const r1 = 59, r2 = 49, r3 = 39;
  const a = Math.max(0, areaKm2);
  const s1 = Math.min(a, t1) * r1;
  const s2 = Math.max(0, Math.min(a, t2) - t1) * r2;
  const s3 = Math.max(0, a - t2) * r3;
  const monthly = s1 + s2 + s3;
  return { monthly, total: monthly * Math.max(1, months) };
}

export function formatINR(n) {
  if (!isFinite(n)) return "₹ 0";
  return `₹ ${Math.round(n).toLocaleString("en-IN")}`;
}

export function formatKm2(n) {
  if (!isFinite(n)) return "0 km²";
  return `${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })} km²`;
}
